import React from 'react';
import Card from './Card';

const KPICard = ({ 
  title, 
  value, 
  target, 
  achievementRate,
  icon = true,
  suffix = '' 
}) => {
  return (
    <Card className="!p-3 md:!p-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <span className="text-lg md:text-[20px] md:leading-[30px] font-bold text-[#333333]">
          {title}
        </span>
        {icon && (
          <div className="w-6 h-6 rounded-full bg-[#33564B] outline outline-[0.5px] outline-[#CDCDCD] shrink-0" />
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2 md:gap-3">
        <span className="text-xl md:text-2xl font-semibold text-[#33564B] shrink-0">
          {value}{suffix}
        </span>
        {target && (
          <div className="flex flex-wrap items-center text-xs md:text-sm min-w-0">
            <span className="text-[#5E5E5E] font-semibold mr-1">Target:</span>
            <span className="text-[#333333] font-medium">{target}{suffix}</span>
          </div>
        )}
        {achievementRate && (
          <div className="flex flex-wrap items-center text-xs md:text-sm min-w-0">
            <span className="text-[#5E5E5E] font-semibold mr-1">Achievement:</span>
            <span className="text-[#333333] font-medium">{achievementRate}</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default KPICard;

